import { type JSX } from 'react';

import { useMarketLabelsFromSubevent, useMatchesCouponContext } from '../../hooks';
import { type Bet, type Market, type Subevent } from '../../types';

import { BestOddsButton } from './BestOddsButton';
import { ButtonsWrapper, MarketBetWrapper } from './style';

interface BestOddsButtonsProps {
  betLocation?: string;
  pageTitle?: string;
  subevent: Subevent;
}

export const BestOddsButtons = ({ betLocation, subevent }: BestOddsButtonsProps): JSX.Element => {
  const { markets = [] } = subevent;

  const bettypeIds = useMatchesCouponContext(state => state.bettypeIds) || [];
  const marketLabels = useMarketLabelsFromSubevent();

  const renderBestOddsButtonsMultiMarket = (market: Market, i: number) => {
    const { bets } = market;
    return (
      <MarketBetWrapper key={i}>
        {bets.map((bet: Bet) => (
          <BestOddsButton
            bet={bet}
            betLocation={betLocation}
            key={`${market.id}-${bet.id}`}
            marketName={market.name}
            subeventId={subevent.id}
            subeventName={subevent.name}
          />
        ))}
      </MarketBetWrapper>
    );
  };
  const renderBestOddsButtonsSingleMarket = (label: string, market: Market, i: number) => {
    const { bets } = market;

    return (
      <MarketBetWrapper key={i}>
        {bets
          .filter(bet => bet.genericName === label)
          .map((bet: Bet) => (
            <BestOddsButton
              bet={bet}
              betLocation={betLocation}
              key={`${market.id}-${bet.id}`}
              marketName={market.name}
              subeventId={subevent.id}
              subeventName={subevent.name}
            />
          ))}
      </MarketBetWrapper>
    );
  };

  const buttonsMultiMarket = marketLabels.map((label, i) => {
    const market = markets.find(market => label.betTypeId === market.betTypeId);
    return market ? renderBestOddsButtonsMultiMarket(market, i) : <span key={i} />;
  });
  const buttonsSingleMarket = marketLabels.map((label, i) => {
    const market = markets.find(market => label.betTypeId === market.betTypeId);
    return market ? renderBestOddsButtonsSingleMarket(label.name, market, i) : <span key={i} />;
  });

  return <ButtonsWrapper>{bettypeIds.length === 1 ? buttonsSingleMarket : buttonsMultiMarket}</ButtonsWrapper>;
};
